"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return OAuthAuthorizationCode;
    }
});
const _nanoid = require("nanoid");
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _modelUtils = require("~/utils/modelUtils");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let OAuthAuthorizationCode = class OAuthAuthorizationCode {
    static async insert(authCodeData, ncMeta = _Noco.default.ncMeta) {
        let insertData = (0, _extractProps.extractProps)(authCodeData, [
            'fk_client_id',
            'fk_user_id',
            'code_challenge',
            'code_challenge_method',
            'redirect_uri',
            'scope',
            'state',
            'resource',
            'granted_resources',
            'expires_at'
        ]);
        insertData.code = (0, _nanoid.nanoid)(32);
        insertData = _extends({}, insertData, {
            code_challenge_method: insertData.code_challenge_method || 'S256',
            is_used: false,
            expires_at: new Date(Date.now() + 10 * 60 * 1000).toISOString()
        });
        insertData = (0, _modelUtils.prepareForDb)(insertData, [
            'granted_resources'
        ]);
        await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.OAUTH_AUTHORIZATION_CODES, insertData, true);
        return await this.getByCode(insertData.code, ncMeta);
    }
    static async getByCode(code, ncMeta = _Noco.default.ncMeta) {
        let data = await _NocoCache.default.get('root', `${_globals.CacheScope.OAUTH_AUTH_CODE}:${code}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!data) {
            data = await ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.OAUTH_AUTHORIZATION_CODES, {
                code
            });
            if (data) {
                await _NocoCache.default.setExpiring('root', `${_globals.CacheScope.OAUTH_AUTH_CODE}:${code}`, data, 600);
            }
        }
        return data && this.castType(data);
    }
    static async markAsUsed(code, ncMeta = _Noco.default.ncMeta) {
        await ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.OAUTH_AUTHORIZATION_CODES, {
            is_used: true
        }, {
            code
        });
        await _NocoCache.default.update('root', `${_globals.CacheScope.OAUTH_AUTH_CODE}:${code}`, {
            is_used: true
        });
        return true;
    }
    static async delete(code, ncMeta = _Noco.default.ncMeta) {
        if (!code) {
            return false;
        }
        await _NocoCache.default.deepDel('root', `${_globals.CacheScope.OAUTH_AUTH_CODE}:${code}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        return await ncMeta.metaDelete(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.OAUTH_AUTHORIZATION_CODES, {
            code
        });
    }
    static async deleteAllByClient(clientId, ncMeta = _Noco.default.ncMeta) {
        const BATCH_SIZE = 100;
        let deletedCount = 0;
        // eslint-disable-next-line no-constant-condition
        while(true){
            // Fetch a batch of codes
            const codes = await ncMeta.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.OAUTH_AUTHORIZATION_CODES, {
                condition: {
                    fk_client_id: clientId
                },
                limit: BATCH_SIZE
            });
            if (!codes || codes.length === 0) {
                break;
            }
            for (const code of codes){
                await _NocoCache.default.deepDel('root', `${_globals.CacheScope.OAUTH_AUTH_CODE}:${code.code}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
            }
            const codesToDelete = codes.map((c)=>c.code);
            await ncMeta.metaDelete(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.OAUTH_AUTHORIZATION_CODES, {
                code: {
                    in: codesToDelete
                }
            });
            deletedCount += codes.length;
            // If we got fewer than BATCH_SIZE, we're done
            if (codes.length < BATCH_SIZE) {
                break;
            }
        }
        return deletedCount;
    }
    static castType(authCode) {
        if (!authCode) return null;
        authCode = (0, _modelUtils.prepareForResponse)(authCode, [
            'granted_resources'
        ]);
        return new OAuthAuthorizationCode(authCode);
    }
    constructor(authCode){
        Object.assign(this, authCode);
    }
};
